import { render, staticRenderFns } from "./PrintHeader.vue?vue&type=template&id=bae91ef2&scoped=true"
import script from "./PrintHeader.vue?vue&type=script&lang=js"
export * from "./PrintHeader.vue?vue&type=script&lang=js"
import style0 from "./PrintHeader.vue?vue&type=style&index=0&id=bae91ef2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae91ef2",
  null
  
)

export default component.exports